/**
 * 入力項目名
 * @type     {object} 入力項目定義
 * @property {object} LOGIN ログイン
 * @property {object} COMPANY 企業検索
 * @property {object} UPLOAD 企業情報更新
 */
export const INPUT = {
  LOGIN: {
    USER_ID: 'ログインID',
    PASSWORD: 'パスワード',
  },
  COMPANY: {
    SEARCH_CONDITION: '検索条件',
    COMPANY_NAME: '企業名',
    DUNS: 'D&B D-U-N-S® Number',
    KIGYO_CODE: 'TSRコード',
    CORPORATE_NUMBER: '法人番号',
  },
  UPLOAD: {
    EXCUTION_DATE: '年月日',
    ADDITIONAL_ITEMS_FILE: '取引情報',
  },
  USERMANAGED: {
    OLD_PASSWORD: '元のパスワード',
    NEW_PASSWORD: '新規パスワード',
    NEW_PASSWORD_CONFIRM: '新規パスワード(確認用)',
    SEARCH_USER_ID: 'ログインID',
    SEARCH_USER_NAME: 'ユーザー名',
    RESET_USER_LIST: 'パスワードリセット対象ユーザー',
    UPDATE_USER_NAME: 'ユーザー名',
  },
  MATCHING: {
    EXCUTION_DATE: '年月日',
    MATCHING_FILE: 'マッチング設定ファイル',
  },
  EXTERNALDATA: {
    PROCESSNO: '処理番号',
    COOPERATIONDATE: '連携日',
    STATUS: 'ステータス',
    TSRCD: 'TSRコード',
    TSRCOMPANYCD: 'TSR企業コード',
    OWNERNAME: '取引情報キー',
    CREATEDATE: '作成日',
  },
};
/**
 * API呼び出し共通関数の結果コード
 * @type     {object} 結果コード
 * @property {number} SUCCESS 正常
 * @property {number} ERROR エラー
 * @property {number} WARN 警告
 * @property {number} NOT_FOUND 取得件数0件
 * @property {number} CANCEL キャンセル
 * @property {number} ANOMALY 異常
 */
export const RESULT_CODE = {
  SUCCESS: 0,
  ERROR: 1,
  WARN: 2,
  NOT_FOUND: 3,
  CANCEL: 8,
  ANOMALY: 9,
};
/**
 * ステータス
 * @type     {object} ステータス
 * @property {number} PROCESSING 処理中
 * @property {number} CHECK_OK チェックOK
 * @property {number} CHECK_NG チェックNG
 * @property {number} ACCEPTING 受付中
 * @property {number} SUCCESS_OK 正常終了
 * @property {number} SUCCESS_NG 正常終了(除外レコードあり)
 * @property {number} CANCEL キャンセル
 * @property {number} INTERRUPT 中断
 * @property {number} ANOMALY 異常終了
 * @property {number} WAIT_CREATE_FILE ファイル作成待ち
 * @property {number} CREATE_FILE ファイル作成待ち
 */
export const PROCESS_STATUS = {
  PROCESSING: 1,
  CHECK_OK: 2,
  CHECK_NG: 3,
  ACCEPTING: 4,
  SUCCESS_OK: 5,
  SUCCESS_NG: 6,
  CANCEL: 7,
  INTERRUPT: 8,
  ANOMALY: 9,
};
/**
 * ステータス_マッチング
 * @type     {object} ステータス_マッチング
 * @property {number} CHECK_PROCESSING チェック処理中
 * @property {number} CHECK_OK チェックOK
 * @property {number} CHECK_NG チェックNG
 * @property {number} MATCHING_PROCESSING マッチング処理中
 * @property {number} WAIT_CREATE_FILE ファイル作成待ち
 * @property {number} CREATE_FILE ファイル作成待ち
 * @property {number} SUCCESS 正常終了
 * @property {number} STOP 停止
 * @property {number} ANOMALY 異常終了
 */
export const PROCESS_STATUS_MATCHING = {
  CHECK_PROCESSING: 1,
  CHECK_OK: 2,
  CHECK_NG: 3,
  MATCHING_PROCESSING: 4,
  SUCCESS: 5,
  WAIT_CREATE_FILE: 6,
  CREATE_FILE: 7,
  STOP: 8,
  ANOMALY: 9,
};
/**
 * 機能区分
 * @type     {object} 機能区分
 * @property {string} COMPANY_DOWNLOAD 企業検索ダウンロード
 * @property {string} TARGET_DOWNLOAD ターゲット検索ダウンロード
 * @property {string} COMPANY_UPLOAD 企業情報更新
 */
export const FUNC_TYPE = {
  COMPANY_DOWNLOAD: '11',
  TARGET_DOWNLOAD: '12',
  COMPANY_UPLOAD: '21',
};
/**
 * ファイル区分
 * @type     {object} ファイル区分
 * @property {number} FILE_NAME_SERVER サーバ上のファイル名
 * @property {number} FILE_NAME_UPLOAD アップロードファイル名
 */
export const FILE_TYPE = {
  FILE_NAME_SERVER: 1,
  FILE_NAME_UPLOAD: 2,
};
/**
 * 権限コード
 * @type     {object} 権限コード
 * @property {string} COMPANY 系列企業ツリー
 * @property {string} TARGET ターゲティング
 * @property {string} MATCHING マッチング
 * @property {string} UPLOAD 取引情報アップロード
 * @property {string} USERMANAGED ユーザー管理機能利用
 * @property {string} LOGOUTPUT 利用状況照会
 * @property {string} EXTERNALDATA 利用状況照会
 */
export const ROLE_CODE = {
  COMPANY: '10',
  TARGET: '20',
  MATCHING: '30',
  UPLOAD: '91',
  USERMANAGED: '92',
  LOGOUTPUT: '93',
  EXTERNALDATA: '94',
};
/**
 * 検索対象
 * @type     {object} 検索対象
 * @property {number} COMPANY_NAME 企業名（部分一致）
 * @property {number} DUNS DUNS
 * @property {number} COMPANY_NAME_PERFECT 企業名（完全一致）
 * @property {number} KIGYO_CODE TSRコード
 * @property {number} CORPORATE_NUMBER 法人番号（完全一致）
 */
export const SEARCH_TARGET = {
  COMPANY_NAME: 1,
  DUNS: 2,
  COMPANY_NAME_PERFECT: 3,
  KIGYO_CODE: 4,
  CORPORATE_NUMBER: 5,
};
/**
 * 企業名検索区分
 * @type     {object} 企業名検索区分
 * @property {number} PARTIAL 部分一致
 * @property {number} PERFECT 完全一致
 */
export const COMPANY_SEARCH_TYPE = {
  PARTIAL: 1,
  PERFECT: 2,
  PREFIX: 3,
  SUFFIX: 4,
};
/**
 * ダウンロード対象
 * @type     {object} ダウンロード対象
 * @property {string} HEAD_OFFICE 本社のみ
 * @property {string} MFP MFPのみ
 */
export const DOWNLOAD_TARGET = {
  HEAD_OFFICE: '1',
  MFP: '2',
};
/**
 * ダウンロード項目
 * @type     {object} ダウンロード項目
 * @property {string} MINIMUM カスタムレイアウト
 * @property {string} ALL 全項目
 */
export const DOWNLOAD_VALUE = {
  MINIMUM: '1',
  ALL: '2',
  TSR_ONLY: '3',
};
/**
 * 有無フラグ
 * @type     {object} 有無フラグ
 * @property {number} NONE 無し
 * @property {number} FOUND 有り
 */
export const EXISTS = {
  NONE: '0',
  FOUND: '1',
};
/**
 * エラー区分
 * @type     {object} エラー区分
 * @property {string} SUCCESS 正常
 * @property {string} AUTH_NG 認証NG
 * @property {string} CSRF_NONE CSRFトークン無効
 * @property {string} CLOSE 閉塞中
 */
export const SYSTEM_ERROR_TYPE = {
  SUCCESS: '00',
  AUTH_NG: '11',
  CSRF_NONE: '21',
  CLOSE: '22',
};

/**
 * 階層情報区分値設定
 * @type     {object} 階層情報区分値設定
 * @property {string} COMPANY 企業階層
 * @property {string} FUND 出資率50%超
 * @property {string} AREA 地域階層
 */
export const HIERARCHY_KBN = {
  COMPANY: '1',
  FUND: '2',
  AREA: '3',
};

export const FILTER_TAB_LIST = [
  /* { id: HIERARCHY_KBN.COMPANY, name: '企業階層' }, */
  { id: HIERARCHY_KBN.FUND, name: '国内系列企業' },
  { id: HIERARCHY_KBN.AREA, name: '地域階層' },
];

/**
 * 業種分類識別コード
 * @type     {object} 業種分類識別コード
 * @property {string} INDUSTRY_B 大分類
 * @property {string} INDUSTRY_N 中分類
 * @property {string} INDUSTRY_S 小分類
 * @property {string} INDUSTRY_M 細分類
 */
export const INDUSTRY_KBN = {
  INDUSTRY_B: '1',
  INDUSTRY_N: '2',
  INDUSTRY_S: '3',
  INDUSTRY_M: '4',
};

/**
 * ファイル作成処理区分
 * @type     {object} ファイル作成処理区分
 * @property {string} CREATE_FILE ファイル作成
 * @property {string} DOWNLOAD_POSSIBLE ダウンロード可否
 */
export const CREATE_FILE_PROCESS_KBN = {
  CREATE_FILE: '1',
  DOWNLOAD_POSSIBLE: '2',
};

/**
 * ダウンロード表示ステータス
 * @type     {object} ダウンロード表示ステータス
 */
export const DOWNLOAD_DISP_STATUS = [
  PROCESS_STATUS.PROCESSING,
  PROCESS_STATUS.SUCCESS_OK,
  PROCESS_STATUS.INTERRUPT,
  PROCESS_STATUS.ANOMALY,
];

/**
 * ダウンロードステータスメッセージ
 * @type     {object} ダウンロードステータスメッセージ
 * @property {string} PROCESSING 処理中
 * @property {string} SUCCESS_OK 正常終了
 * @property {string} INTERRUPT 中断
 * @property {string} ANOMALY 異常終了
 */
export const DOWNLOAD_STATUS_MESSAGE = {
  PROCESSING: 'ファイル作成中：{0}件',
  SUCCESS_OK: 'ファイルをダウンロード',
  INTERRUPT: 'ファイル作成中断',
  ANOMALY: 'ファイル作成失敗',
};

/**
 * 企業情報更新タブ識別コード
 * @type     {object} 企業情報更新タブ識別コード
 * @property {string} SETTING データ更新設定
 * @property {string} RESULT  データ更新結果
 */
export const UPLOAD_COMPANY_TAB = {
  SETTING: '1',
  RESULT: '2',
};

/**
 * 企業情報更新件数表示ステータス
 *  ステータスが下記の場合、件数を表示
 *   ・チェックOK
 *   ・受付中
 *   ・正常終了
 *   ・正常終了(除外レコードあり)
 *
 * @type     {object} 企業情報更新件数表示ステータス
 */
export const COUNT_DISP_STATUS = [
  PROCESS_STATUS.CHECK_OK,
  PROCESS_STATUS.ACCEPTING,
  PROCESS_STATUS.SUCCESS_OK,
  PROCESS_STATUS.SUCCESS_NG,
];

/**
 * 企業情報更新エラーファイル表示ステータス
 *  ステータスが下記の場合、件数を表示
 *   ・チェックNG
 *
 * @type     {object} 企業情報更新件数表示ステータス
 */
export const ERRORFILE_DISP_STATUS = [
  PROCESS_STATUS.CHECK_NG,
];

/**
 * 企業情報更新除外レコードファイル表示ステータス
 *  ステータスが下記の場合、件数を表示
 *   ・チェックOK
 *   ・受付中
 *   ・正常終了(除外レコードあり)
 *
 * @type     {object} 企業情報更新件数表示ステータス
 */
export const EXCLUDE_DISP_STATUS = [
  PROCESS_STATUS.CHECK_OK,
  PROCESS_STATUS.ACCEPTING,
  PROCESS_STATUS.SUCCESS_NG,
];

/**
 * 日時フォーマット
 * @type     {object} 日時フォーマット
 * @property {string} DATE_TIME_FULL 日時
 * @property {string} DATE_TIME 日時
 * @property {string} DATE 日付
 * @property {string} TIME 時間
 * @property {string} DATE_TIME_FULL_FILE 日時(ファイル名用)
 */
export const DATE_TIME_FORMAT = {
  DATE_TIME_FULL: 'YYYY/MM/DD HH:mm:ss',
  DATE_TIME: 'YYYY/MM/DD HH:mm',
  DATE: 'YYYY/MM/DD',
  TIME: 'HH:mm:ss',
  DATE_TIME_FULL_FILE: 'YYYYMMDDHHmmss',
};

/**
 * データ更新ファイルアップロード処理区分
 * @type     {object} データ更新ファイルアップロード処理区分
 * @property {number} STATUS_CHECK ステータスチェック
 * @property {number} UPLOAD アップロード開始
 * @property {number} UPDATE データ更新実行
 */
export const FILE_UPLOAD_PROCESS_TYPE = {
  STATUS_CHECK: 1,
  UPLOAD: 2,
  UPDATE: 3,
};

/**
 * 検索条件有り無し
 * @type     {object} 検索条件有り無し
 * @property {string} CONDITION_NONE 条件なし
 * @property {string} CONDITION_TRUE 有り
 * @property {string} CONDITION_FALSE 無し
 */
export const CONDITION_RADIO = {
  CONDITION_NONE: '9',
  CONDITION_TRUE: '1',
  CONDITION_FALSE: '0',
};

/**
 * 検索対象チェックボックス
 * @type     {object} 検索対象チェックボックス
 * @property {string} SEARCH_TARGET_ALL 本社、事業所
 * @property {string} SEARCH_TARGET_ONE 本社のみ
 */
export const SEARCH_TARGET_CONDITION = {
  SEARCH_TARGET_ALL: '2',
  SEARCH_TARGET_ONE: '1',
};

/**
 * 業種チェックボックス
 * @type     {object} 業種チェックボックス
 * @property {string} INDUSTRY_ALL 全て
 * @property {string} INDUSTRY_ONE 主業種のみ
 */
export const INDUSTRY_FLG = {
  INDUSTRY_ALL: '0',
  INDUSTRY_ONE: '1',
};

/**
 * ターゲット検索タブ
 * @type     {object} ターゲット検索タブ
 * @property {string} TAB_SEARCH 検索
 * @property {string} TAB_LIST リスト
 */
export const TARGET_TAB = {
  TAB_SEARCH: 'search',
  TAB_LIST: 'list',
};

/**
 * 企業検索結果(単体)のページングの定義値
 * @type     {object} ページングの定義値
 * @property {number} PAGE_RECORD_COUNT 1ページの表示件数
 * @property {number} BEFORE_PAGE_COUNT 自ページ番号から前に何ページ表示するか
 * @property {number} AFTER_PAGE_COUNT 自ページ番号から後ろに何ページ表示するか
 */
export const COMPANY_RESULT_PAGING = {
  PAGE_RECORD_COUNT: 100,
  BEFORE_PAGE_COUNT: 4,
  AFTER_PAGE_COUNT: 4,
};

/**
 * ターゲット検索のページングの定義値
 * @type     {object} ページングの定義値
 * @property {number} PAGE_RECORD_COUNT 1ページの表示件数
 * @property {number} BEFORE_PAGE_COUNT 自ページ番号から前に何ページ表示するか
 * @property {number} AFTER_PAGE_COUNT 自ページ番号から後ろに何ページ表示するか
 */
export const PAGING = {
  PAGE_RECORD_COUNT: 100,
  BEFORE_PAGE_COUNT: 4,
  AFTER_PAGE_COUNT: 4,
};

/**
 * ユーザー管理検索結果のページングの定義値
 * @type     {object} ページングの定義値
 * @property {number} PAGE_RECORD_COUNT 1ページの表示件数
 * @property {number} BEFORE_PAGE_COUNT 自ページ番号から前に何ページ表示するか
 * @property {number} AFTER_PAGE_COUNT 自ページ番号から後ろに何ページ表示するか
 */
export const USER_RESULTPAGING = {
  PAGE_RECORD_COUNT: 100,
  BEFORE_PAGE_COUNT: 4,
  AFTER_PAGE_COUNT: 4,
};

/**
 * 取引情報ポップアップのページングの定義値
 * @type     {object} ページングの定義値
 * @property {number} PAGE_RECORD_COUNT 1ページの表示件数
 * @property {number} BEFORE_PAGE_COUNT 自ページ番号から前に何ページ表示するか
 * @property {number} AFTER_PAGE_COUNT 自ページ番号から後ろに何ページ表示するか
 */
export const ADDITIONAL_ITEM_PAGING = {
  PAGE_RECORD_COUNT: 20,
  BEFORE_PAGE_COUNT: 4,
  AFTER_PAGE_COUNT: 4,
};

/**
 * 名刺連携履歴検索結果のページングの定義値
 * @type     {object} ページングの定義値
 * @property {number} PAGE_RECORD_COUNT 1ページの表示件数
 * @property {number} BEFORE_PAGE_COUNT 自ページ番号から前に何ページ表示するか
 * @property {number} AFTER_PAGE_COUNT 自ページ番号から後ろに何ページ表示するか
 */
export const EXTERNALDATA_RESULTPAGING = {
  PAGE_RECORD_COUNT: 100,
  BEFORE_PAGE_COUNT: 4,
  AFTER_PAGE_COUNT: 4,
};

/**
 * 表示件数上限定義値
 * @type     {object} 表示件数上限定義値
 * @property {number} COMPANY 企業検索
 * @property {number} TARGET ターゲット
 * @property {number} EXTERNALDATA_HISTORY 名刺連携履歴
 */
export const DISP_COUNT_LIMIT = {
  COMPANY: 1000,
  TARGET: 10000,
  ADDITIONAL_ITEM: 1000,
  EXTERNALDATA_HISTORY: 10000,
};

/**
 * ツリー階層番号
 * @type     {object} ツリー階層番号定義値
 * @property {number} FIRST 第一階層
 * @property {number} AREA 地域
 * @property {number} PREF 都道府県
 * @property {number} OFFICE 事業所
 */
export const TREE_LEVEL = {
  FIRST: 1,
  AREA: 2,
  PREF: 3,
  OFFICE: 9,
};

/**
 * ファイルID
 * @type     {object} ファイルID
 * @property {string} ADDITIONAL_ITEMS_FILE 取引情報
 */
export const FILE_ID = {
  ADDITIONAL_ITEMS_FILE: 'additional-items-file',
};

/**
 * ソート項目
 * @property {string} USER_ID          ユーザーID
 * @property {string} USER_NAME        ユーザー名
 */
export const SORT_ITEM = {
  USER_ID: 'user_id',
  USER_NAME: 'user_name',
};

/**
 * ソート順序
 * @property {string} ASC   昇順
 * @property {string} DESC  降順
 */
export const SORT_ORDER = {
  ASC: 'A',
  DESC: 'D',
};

/**
 * 文字コード
 * @type     {object} 文字コード
 * @property {string} UTF8 UTF-8
 * @property {string} SJIS SJIS
 */
export const CHAR_CODE = {
  UTF8: '1',
  SJIS: '2',
};

/**
 * 企業情報マッチングタブ識別コード
 * @type     {object} 企業情報更新タブ識別コード
 * @property {string} SETTING マッチング設定
 * @property {string} RESULT  マッチング結果
 */
export const MATCHING_COMPANY_TAB = {
  SETTING: '1',
  RESULT: '2',
};

/**
 * 文字コード(マッチング)
 * @type     {object} 文字コード(マッチング)
 * @property {string} UTF8 UTF-8
 * @property {string} SJIS SJIS
 */
export const CHAR_CODE_MATCHING = {
  UTF8: 'UTF-8',
  SJIS: 'MS932',
};

/**
 * 区切り文字(マッチング)
 * @type     {object} 区切り文字
 * @property {string} COMMA ,
 * @property {string} TAB [t]
 */
export const DELIMITER_MATCHING = {
  COMMA: ',',
  TAB: '\t',
};

/**
 * 企業情報マッチング更新ボタン表示ステータス
 *  ステータスが下記の場合、更新ボタンを表示
 *   ・チェック処理中
 *   ・チェックOK
 *   ・マッチング処理中
 *   ・ファイル作成中
 *
 * @type     {object} 企業情報マッチング更新ボタン表示ステータス
 */
export const UPDATE_BUTTON_DISP_STATUS = [
  PROCESS_STATUS_MATCHING.CHECK_PROCESSING,
  PROCESS_STATUS_MATCHING.CHECK_OK,
  PROCESS_STATUS_MATCHING.MATCHING_PROCESSING,
  PROCESS_STATUS_MATCHING.CREATE_FILE,
];

/**
 * 企業情報マッチングファイル作成ボタン表示ステータス
 *  ステータスが下記の場合、ファイル作成ボタンを表示
 *   ・ファイル作成待ち
 *
 * @type     {object} 企業情報マッチングファイル作成ボタン表示ステータス
 */
export const CREATE_BUTTON_DISP_STATUS = [
  PROCESS_STATUS_MATCHING.WAIT_CREATE_FILE,
];

/**
 * 企業情報マッチングダウンロードボタン表示ステータス
 *  ステータスが下記の場合、ダウンロードボタンを表示
 *   ・成功
 *
 * @type     {object} 企業情報マッチングファイル作成ボタン表示ステータス
 */
export const DOWNLOAD_BUTTON_DISP_STATUS = [
  PROCESS_STATUS_MATCHING.SUCCESS,
];

/**
 * 企業情報マッチングエラーダウンロードボタン表示ステータス
 *  ステータスが下記の場合、エラーダウンロードボタンを表示
 *   ・チェックNG
 *   ・異常終了
 *
 * @type     {object} 企業情報マッチングエラーダウンロードボタン表示ステータス
 */
export const ERROR_DOWNLOAD_BUTTON_DISP_STATUS = [
  PROCESS_STATUS_MATCHING.CHECK_NG,
];

/**
 *
 * 取引情報ポップアップの画面表示設定
 *
 * @type     {object} 企業情報マッチングエラーダウンロードボタン表示ステータス
 * @property {number} POSITION_Y 画面上端からの距離
 * @property {number} MIN_WIDTH 最小の横幅
 * @property {number} MIN_HEIGHT 最小の縦幅
 */
export const ADDITIONAL_ITEM_DISP_SETTINGS = {
  POSITION_Y: 20,
  MIN_WIDTH: 650,
  MIN_HEIGHT: 300,
};

/**
 *
 * 利用状況照会の機能選択項目
 *
 * @type     {object} 利用状況照会の機能選択項目
 * @property {string} ALL 全て
 * @property {string} COMPANY 系列企業ツリー
 * @property {string} TARGETING ターゲティング
 * @property {string} MATCHING マッチング
 * @property {string} ADMIN 管理者メニュー
 */
export const LOGOUTPUT_ACTIONS = {
  ALL: '全て',
  COMPANY: '系列企業ツリー',
  TARGETING: 'ターゲティング',
  MATCHING: 'マッチング',
  ADMIN: '管理者メニュー',
};

/**
 * 企業詳細非表示
 * @type     {object} 企業詳細非表示
 * @property {string} MESSAGE メッセージ
 */
export const COMPANY_DETAIL_BLIND = {
  MESSAGE: '公開対象外の業種のため、詳細は表示できません。',
};

/**
 * ライト版フラグ
 * @type     {object} ライト版フラグ識別コード
 * @property {string} ON ライト版フラグあり
 * @property {string} OFF  ライト版フラグ無し
 */
export const LIGHT_FLG = {
  ON: '1',
  OFF: '0',
};

/**
 * DUNS未使用フラグ
 * @type     {object} DUNS未使用フラグ識別コード
 * @property {number} ON DUNS未使用フラグあり
 * @property {number} OFF  DUNS未使用フラグ無し
 */
export const DUNS_NOT_USED_FLG = {
  ON: '1',
  OFF: '0',
};

/**
 * お客様取引情報項目取得マスタ区分コード
 * @type     {object} お客様取引情報項目取得マスタ区分コード識別コード
 * @property {number} SEARCH  ターゲット検索の取引情報任意項目
 * @property {number} RESULT  ターゲット検索の結果表示における取引情報
 */
export const TARGET_TRADE_DIVISION_CODE = {
  SEARCH: 1,
  RESULT: 2,
};

/**
 * お客様取引情報検索精度
 * @type     {object} お客様取引情報検索精度
 * @property {string} EXACT 完全一致
 * @property {string} FORWARD 前方一致
 * @property {string} BACKWARD 後方一致
 * @property {string} PART 部分一致
 */
export const TRADE_CONDITION_RADIO = {
  CONDITION_EXACT: '2',
  CONDITION_FORWARD: '3',
  CONDITION_BACKWARD: '4',
  CONDITION_PART: '1',
};

/**
 * ターゲット検索一覧で表示する項目のカテゴリ
 * @type     {object} ターゲット検索一覧で表示する項目のカテゴリ
 * @property {number} KIGYO 企業
 * @property {number} JIGYOSYO 事業所
 * @property {number} TORIHIKI 取引情報
 * @property {number} KIGYO_KIHON 企業(契約区分が基本項目の場合)
 * @property {number} JIGYOSYO_KIHON 事業所(契約区分が基本項目の場合)
 * @property {number} TORIHIKI_KIHON 取引情報(契約区分が基本項目の場合)
 */
export const TARGET_LIST_CATEGORY = {
  LIST_CATEGORY1: '1',
  LIST_CATEGORY2: '2',
  LIST_CATEGORY3: '3',
  LIST_CATEGORY4: '4',
  LIST_CATEGORY5: '5',
  LIST_CATEGORY6: '6',
  LIST_CATEGORY7: '7',
  LIST_CATEGORY8: '8',
  LIST_CATEGORY9: '9',
  LIST_CATEGORY10: '10',
  LIST_CATEGORY11: '11',
  LIST_CATEGORY12: '12',
  LIST_CATEGORY13: '13',
  LIST_CATEGORY14: '14',
  LIST_CATEGORY15: '15',
  LIST_CATEGORY16: '16',
  LIST_CATEGORY17: '17',
};

/**
 * ターゲット検索一覧のカテゴリ毎の項目数
 * @type     {object} ターゲット検索一覧のカテゴリ毎の項目数
 * @property {number} KIGYO 企業
 * @property {number} JIGYOSYO 事業所
 * @property {number} TORIHIKI 取引情報（マスタに依存するので仮で99を設定）
 * @property {number} KIGYO_KIHON 企業(契約区分が基本項目の場合)
 * @property {number} JIGYOSYO_KIHON 事業所(契約区分が基本項目の場合)
 * @property {number} TORIHIKI_KIHON 取引情報(契約区分が基本項目の場合)（マスタに依存するので仮で99を設定）
 */
export const TARGET_LIST_CATEGORY_COLUMN_COUNT = {
  KIGYO: 5,
  JIGYOSYO: 6,
  TORIHIKI: 99,
  KIGYO_KIHON: 2,
  JIGYOSYO_KIHON: 3,
  TORIHIKI_KIHON: 99,
};

/**
 * トライアル版フラグ
 * @type     {object} トライアル版フラグ識別コード
 * @property {string} ON トライアル版フラグあり
 * @property {string} OFF  トライアル版フラグ無し
 */
export const TRIAL_FLG = {
  ON: '1',
  OFF: '0',
};

/**
 * 外部データ取込履歴タブ
 * @type     {object} ターゲット検索タブ
 * @property {string} TAB_INPORT 外部データ取込
 * @property {string} TAB_EXPORT 外部送信
 */
export const EXTERNALDATA_TAB = {
  TAB_INPORT: 'inport',
  TAB_EXPORT: 'export',
};

/**
 * 外部データ取込履歴ステータス
 * @type     {object} 名刺連携履歴のステータス項目
 */
export const EXTERNALDATA_STATUS = [
  { key: '11', value: '登録完了' },
  { key: '12', value: '登録不可' },
  { key: '21', value: '削除完了' },
  { key: '22', value: '削除不可' },
];

/**
 * 契約ラベル
 * @type     {object} 契約ラベルの配列位置番号
 * @property {string} COMPANY_DETAIL_BUTTON TREE_LINK_LABEL
 * @property {string} TARGET_INFO_CATEGORY KENSAKUTAISHO_LABEL
 * @property {string} TARGET_INFO_CHOICE1 KENSAKUTAISHO_ARI_LABEL
 * @property {string} TARGET_INFO_CHOICE2 KENSAKUTAISHO_NASHI_LABEL
 * @property {string} TARGET_INFO_CHOICE3 KENSAKUTAISHO_ALL_LABEL
 * @property {string} TARGET_ADDITIONAL_CATEGORY NINNIJOKEN_LABEL
 * @property {string} TARGET_ADDITIONAL_MSG CHUSHAKU_LABEL
 */

export const CONTRACT_LABEL = {
  COMPANY_DETAIL_BUTTON: 'TREE_LINK_LABEL',
  TARGET_INFO_CATEGORY: 'KENSAKUTAISHO_LABEL',
  TARGET_INFO_CHOICE1: 'KENSAKUTAISHO_ARI_LABEL',
  TARGET_INFO_CHOICE2: 'KENSAKUTAISHO_NASHI_LABEL',
  TARGET_INFO_CHOICE3: 'KENSAKUTAISHO_ALL_LABEL',
  TARGET_ADDITIONAL_CATEGORY: 'NINNIJOKEN_LABEL',
  TARGET_ADDITIONAL_MSG: 'CHUSHAKU_LABEL',
  TARGET_ADDITIONAL_BUTTON: 'NINNIJOKEN_BUTTON_LABEL',
};

/**
 * 共通連携履歴ヘッダ―ステータス
 * @type     {object} ステータス
 * @property {number} ACCEPT 受付完了
 * @property {number} PROCESSING 処理中
 * @property {number} SUCCESS 正常終了
 * @property {number} ANOMALY 異常終了
 */
export const TR_COMMON_HISTORY_STATUS = {
  ACCEPT: 0,
  PROCESSING: 1,
  SUCCESS: 2,
  ANOMALY: 9,
};

/**
 * 表示カテゴリ
 * @type     {object} カテゴリ
 * @property {number} BASE_INFO 拠点情報
 * @property {number} COMPANY_INFO 企業情報
 */
export const DIPS_CATEGORY = {
  BASE_INFO: 1,
  COMPANY_INFO: 2,
};

/**
 * 種別コード
 * @type     {object} お客様取引情報項目取得マスタ区分コード識別コード
 * @property {string} CODE  コードマスタ取得のための種別コード
 */
export const SHUBETSU_CODE = {
  CD0008: 'CD0008',
  CD0023: 'CD0023',
  CD0047: 'CD0047',
};

/**
 * マスタ取得フラグ
 * @type     {object} マスタ取得有無
 * @property {string} ON 取得する
 * @property {string} OFF 取得しない
 */
export const GET_MASTER_FLG = {
  ON: '1',
  OFF: '0',
};

/**
 * 保存フラグ
 * @type     {object} 検索条件保存識別コード
 * @property {string} ON 保存する
 * @property {string} OFF 検索する
 */
export const GET_SAVE_FLG = {
  ON: '1',
  OFF: '0',
};

/**
 * 検索精度
 * @type     {object} 検索精度
 * @property {string} EXACT 完全一致
 * @property {string} FORWARD 前方一致
 * @property {string} BACKWARD 後方一致
 * @property {string} PART 部分一致
 */
export const PATTERN_MATCH = {
  EXACT: '1',
  FORWARD: '2',
  BACKWARD: '3',
  PART: '4',
};

/**
 * 最新期チェックボックス
 * @type     {object} 最新期チェックボックス
 * @property {string} LATEST_OFF 最新期のみでない
 * @property {string} LATEST_ON 最新期のみ
 */
export const LATEST_FLG = {
  LATEST_OFF: '0',
  LATEST_ON: '1',
};

/**
 * 企業選択の区分
 * @type     {object} 企業選択の区分
 * @property {string} CUSTOMER 販売先
 * @property {string} SUPPLIER 仕入先
 * @property {string} TOPCOMPANY 国内最上位親会社
 */
export const COMPANY_POP_KBN = {
  CUSTOMER: '0',
  SUPPLIER: '1',
  TOPCOMPANY: '2',
};

/**
 * 検索区分
 * @type     {object} 企業選択の検索区分
 * @property {string} POPUP_LIST_SEARCH ポップアップ一覧検索
 * @property {string} REFLECTED_TARGET_CONDITIONS 保存条件反映時検索
 */
export const SEARCH_KBN = {
  POPUP_LIST_SEARCH: '1',
  REFLECTED_TARGET_CONDITIONS: '2',
};

/**
 * ターゲット検索表示制御項目
 */
export const TARGET_SEARCH_DISP_ITEM = {
  GAIKYO: 'SYRK_GKNY',
  HYOTEN: 'SG_GOKI_HYTN_1',
  KAKUDUKE: 'TSR_KDKB',
  URIAGEDAKA: 'GYSI_URAG',
  URIAGESINTYORITU: 'URAG_SCHR',
  RIEKIKIN: 'GYSI_REK',
  RIEKISINTYORITU: 'RCHR',
  HANBAISAKI: 'HNBSK',
  SIRESAKI: 'SRSK',
  JIGYOSYOKBN: 'JGKB',
  SETTLEMENT: 'SETTLEMENT',
};

/**
 * ターゲット検索結果一覧画面表示制御項目
 */
export const TARGET_SEARCH_RESULT_DISP_ITEM = {
  GYOSYU: 'GYSH',
  JYUGYOINSU: 'JUSU',
  URIAGEDAKA: 'SNTI_GYSI_URAG_1_ALL',
};

/**
 * 最大追加件数
 */
export const ADD_LIMIT_COUNT = {
  INDUSTRY: 100,
  AREA: 100,
  COMPANY: 100,
  PRODUCT: 100,
  TRADE: 100,
};

/**
 * 項目名英字
 * @type     {object} 事業所詳細情報の項目名
 * @property {string} OYA_DUNS 国内親会社D&B D-U-N-S® Number
 * @property {string} SIJO_OYA_DUNS 国内最上位親会社D&B D-U-N-S® Number
 * @property {string} OYA_TSR 国内親会社TSRコード
 * @property {string} SIJO_OYA_TSR 国内最上位親会社TSRコード
 */
export const ITEM_NAME_EN = {
  OYA_DUNS: 'OYA_DUNS',
  SIJO_OYA_DUNS: 'SIJO_OYA_DUNS',
  OYA_TSR: 'OYA_TSR',
  SIJO_OYA_TSR: 'SIJO_OYA_TSR',
  KGY_URL: 'KGY_URL',
};

/**
 * MAPアイコン表示フラグ
 * @type     {object} 所在地のMAPアイコンを表示するフラグ
 * @property {string} LINK_OFF MAPアイコン非表示
 * @property {string} LINK_ON MAPアイコン表示
 */
export const MAP_ICON_FLG = {
  MAP_ICON_OFF: '0',
  MAP_ICON_ON: '1',
};

/**
 * 外部連携ファイル作成 送信区分
 * @type     {object} 外部連携ファイル作成 送信区分
 * @property {string} SEND_SALESFORCE Salesforce連携
 * @property {string} SEND_EXTERNAL API外部連携
 */
export const SEND_TYPE = {
  SALESFORCE: '1',
  EXTERNAL: '2',
};

/**
 * Salesforce連携 連携方式区分
 * @type     {object} Salesforce連携 連携方式区分
 * @property {string} INSERT Insert
 * @property {string} UPSERT Upsert
 */
export const MODE_KBN = {
  INSERT: 1,
  UPSERT: 2,
};

/**
 * Salesforce連携 連携方式区分
 * @type     {object} Salesforce連携 連携方式区分
 * @property {string} INSERT Insert
 * @property {string} UPSERT Upsert
 */
export const MODE_KBN_NAME = {
  INSERT: 'Insert（全て新規登録）',
  UPSERT: 'Upsert（xxx）による更新、登録',
};
